import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ComparisonCard from "../components/ComparisonCard";
import ComparisonSearch from "../components/ComparisonSearch";
import { comparisonSearchData, featchCarData } from "../Redux/Slice/DataSlice";
import Spinner from "../components/Spinner";

const Comparison = () => {
  const {compareData1,compareData2,status} = useSelector((state) => state.CarData);
  const dispatch=useDispatch()
  const [holdData, setholdData] = useState(false)

  useEffect(()=>{
    dispatch(featchCarData()).then(()=>{
      dispatch(comparisonSearchData({searchData1:"Mercedes-Benz EQS",searchData2:"Mahindra Thar"}))
      setholdData(true)
    })

  },[])

  return (
    <>
    <div className="w-[100%]">

    {  
      status==="pending" ?
          <Spinner/>
    :



    <div className="w-[100%]">
      <ComparisonSearch />
      <div className="min-h-[80vh] w-[100%] flex justify-center items-center ">
        <div className=" flex justify-center sm:w-[70%] w-[90%] items-start flex-col sm:flex-row  mt-3 ml-3 shadow-2xl py-2 rounded-md ">
        {
            holdData==true?
            
            <ComparisonCard car1={compareData1} car2={compareData2}  />:""
          } 
            
           
        </div>
      </div>
      </div>

    }

      </div>
    </>
  );
};

export default Comparison;
